import {
  EntityColumns,
  EntityTableColumnProvider,
} from '../../../../../hooks/useEntityTableColumnsProvider';
import { YColumnsType } from '@ydistri/ds';
import { computeRemSize } from '@ydistri/theme';

export const getStoreColumnsForPickingPerformance = <T>(
  columnsProvider: EntityTableColumnProvider,
): YColumnsType<T>[] => {
  return columnsProvider<T>({
    [EntityColumns.NAME]: {
      width: computeRemSize(260),
    },
    [EntityColumns.ID]: {
      width: computeRemSize(100),
      align: 'center',
    },
    [EntityColumns.CODE]: {
      width: computeRemSize(100),
    },
  });
};
